import React from 'react';
import { ServerStatus } from '../../../types/models/server-status';
import { ServerStatusItem } from './server-status-item';
interface ServerStatusesProps {
  statuses: Array<ServerStatus>;
}

export function ServerStatuses(props: ServerStatusesProps) {
  return (
    <>
      {props.statuses.map((s) => (
        <ServerStatusItem key={s.id} status={s} />
      ))}
    </>
  );
}
